import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {LaunchDialogService} from '@spartacus/storefront';
import {Observable} from 'rxjs';

import {AimoProduct} from '../../../model/product.model';
import {AimoGTMProductAttributes, GTMCartType, GTMItemListId} from '../../../service/gtm/aimo-gtm.model';
import {AimoGtmService} from '../../../service/gtm/aimo-gtm.service';
import {AimoProductModalService} from '../../../service/product/aimo-product-modal.service';
import {AimoProductComparisonService} from '../../../service/user/aimo-product-comparison.service';

import {PRODUCT_COMPARISON} from './comparison-layout.config';
import {AimoCurrentProductService} from "../../../service/product/aimo-current-product.service";


@Component({
    selector: 'aimo-product-comparison-preview',
    templateUrl: './aimo-product-comparison-preview.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoProductComparisonPreviewComponent implements OnInit {
    products$: Observable<AimoProduct[]>;

    constructor(
        protected productComparisonService: AimoProductComparisonService,
        protected launchDialogService: LaunchDialogService,
        protected currentProductService: AimoCurrentProductService,
        protected gtmService: AimoGtmService,
        protected productModalService: AimoProductModalService,
    ) {
    }

    ngOnInit(): void {
        this.products$ = this.productComparisonService.getCompareProducts(0, 9999);
    }

    remove(product: AimoProduct): void {
        this.productComparisonService.removeProductFromComparison(product.code);
    }

    clear(): void {
        this.productComparisonService.clear();
        this.launchDialogService.closeDialog(null);
    }

    compare(): void {
        this.launchDialogService.closeDialog(null);
        this.launchDialogService.openDialogAndSubscribe(PRODUCT_COMPARISON, undefined);
    }

    openProductModal(product: AimoProduct, idx: number, sourceId: string): void {
        this.productModalService.openProductModal(
            product.code,
            this.createGtmAttributes(idx, product),
            null,
            null,
            null,
            sourceId,
        );
    }

    createGtmAttributes(idx: number, product: AimoProduct): AimoGTMProductAttributes {
        return {
            ...this.gtmService.createProductGtmAttributesBase(product, GTMItemListId.product_comparison),
            index: idx,
            cart_type: GTMCartType.cart,
        } as AimoGTMProductAttributes;
    }
}
